<template>
  <!-- eslint-disable -->
  <v-dialog v-model="dialog" persistent max-width="750px">
    <div class="client-settings-dialog" v-if="selectedClient || editClient">
      <v-toolbar style="background-color: #f5f5f5;">
        <v-toolbar-title style="padding-right: 10px;">
          <v-avatar large class="red">
            <span v-if="editMode" class="white--text headline">
              {{ editClient.Name ? editClient.Name.match(/\b(\w)/g)[0].toUpperCase() : ""}}
            </span>
            <span v-else class="white--text headline">
              {{ selectedClient.Name ? selectedClient.Name.match(/\b(\w)/g)[0].toUpperCase() : ""}}
            </span>
          </v-avatar>
        </v-toolbar-title>
        <v-toolbar-title>{{selectedClient.Name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon v-show="currentDialog != 'clientOverview'" @click="back()">
            <v-icon small>arrow_back</v-icon>
          </v-btn>
          <v-btn icon v-show="!editMode" @click="edit()">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn icon v-show="editMode" @click="closeEdit()">
            <v-icon small>settings_backup_restore</v-icon>
          </v-btn>
          <v-btn icon v-show="editMode && !savingClient" :disabled="savingClient || !valid" @click="saveClient()">
            <v-icon small>save</v-icon>
          </v-btn>
          <span v-if="savingClient" style="font-weight: 500; position: relative; top: 18px;">Saving....</span>
          <v-btn icon @click.native="reset()">
            <v-icon small>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card style="border-radius: 0;">
        <v-form v-model="valid" ref="form" lazy-validation  class="client-dialog-form">
  <!----Client Info---->
          <v-card-text id="client-detail" v-show="currentDialog == 'clientOverview'" style="padding: 0;">
            <v-container>
              <div class="form-title" style="padding-top: 0;">Client Info</div>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-text-field :disabled="!editMode" label="Client Name" v-model="editClient.Name" required prepend-icon="account_box" :rules="[rulesRequired]"></v-text-field>
                </v-flex>
                <v-flex xs6 px-3 class="center-content">
                  <v-checkbox :disabled="!editMode" v-model="editClient.IsActive" label="Active"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Address Line 1" v-model="editClient.Address.Line1" :rules="[rulesRequired]"></v-text-field>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field :disabled="!editMode" label="Address Line 2" v-model="editClient.Address.Line2"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="City" v-model="editClient.Address.City" :rules="[rulesRequired]"></v-text-field>
                </v-flex>
                <v-flex xs2 px-2>
                  <v-select  :disabled="!editMode" :items="states" v-model="editClient.Address.State" label="State" :rules="[rulesRequired]"></v-select>
                </v-flex>
                <v-flex xs4 px-3>
                  <v-text-field  :disabled="!editMode" label="Zip" v-model="editClient.Address.Zip" :rules="[rulesRequired, rulesZip]"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Phone Number" v-model="editClient.Address.Phone" prepend-icon="phone" :rules="[rulesPhone]"></v-text-field>
                </v-flex>
              </v-layout>
              <div class="form-title">Coolant Expiration</div>
              <v-layout>
                <v-flex xs6 px-3>
                  <v-select :disabled="!editMode" :clearable="true" :items="coolantExpirationOptions" item-text="Label" item-value="Value" v-model="editClient.CoolantCalculationDateSource" label="Coolant Calculation Source"></v-select>
                </v-flex>
                <v-flex xs3 px-3>
                  <v-menu :close-on-content-click="false" :fixed="true" :nudge-right="33" :nudge-bottom="46"  :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-on="on" prepend-icon="access_time" :value="formatTime(editClient.CoolantStartTime, 'AmPm')" :disabled="!editMode"  label="Start Time" readonly></v-text-field>
                    </template>
                    <v-time-picker v-if="editMode" :disabled="!editMode" v-model="editClient.CoolantStartTime"></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 px-3>
                  <v-text-field  :disabled="!editMode" label="Expiration" suffix="hrs" single-line v-model="editClient.CoolantExpirationHours"  type="number"></v-text-field>
                </v-flex>
              </v-layout>    
              <v-layout row>
                <v-flex xs6 px-3>
                  <div class="form-label">Default Value</div>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Default Value" single-line v-model="editClient.DefaultPackageValue" :rules="[rules.defaultValue]"  type="number" prepend-icon="attach_money"></v-text-field>
                </v-flex>
              </v-layout>
              <div class="form-title">Locations <v-btn v-if="editMode" depressed small px-3 style="float: right; margin: 0 16px 0 0;" @click="editLocation()">Add</v-btn></div>
              <v-layout row style="width: 100%; margin-bottom: 15px;">
                <v-flex xs12 px-3>
                  <v-data-table :mobile-breakpoint="0" :items="editClient.Locations" item-key="Id" :headers="headers.clientDialogHeaders" hide-default-footer >
                    <template v-slot:item="{ item }" item-key="HashKey">
                      <tr @click="editLocation(item)">
                        <td>{{item.Name}}</td>
                        <td class="center-content"><v-checkbox style="margin: auto; width: 20px; position: relative; top: 10px;" v-model="item.IsActive" :disabled="!editMode" :readonly="true"></v-checkbox></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout justify-center>
                <v-flex xs4 style="text-align: center;" v-if="false">
                  <v-btn depressed @click="viewCallOptions(editClient)">Call Options</v-btn>
                </v-flex>
                <v-flex xs6 style="text-align: center;">
                  <v-btn depressed @click="viewClientOptions(editClient)">Client Options</v-btn>
                </v-flex>
                <v-flex xs6 style="text-align: center;">
                  <v-btn depressed @click="viewBillingOptions(editClient)">Billing Options</v-btn>
                </v-flex>            
              </v-layout>
            </v-container>
          </v-card-text>
  <!----Client Options---->
          <v-card-text v-show="currentDialog == 'clientOptionsOverview' && clientOptionEditData" style="padding: 0;">
            <v-container>
              <div class="form-title" style="padding-bottom: 15px;">Client Options</div>
              <div class="px-3">
                <v-expansion-panels>
                  <v-expansion-panel v-for="cat in clientOptionEditData" :key="cat.Id" >
                    <v-expansion-panel-header>
                      <h4>{{cat.Name}}</h4>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card>
                        <v-card-text style="padding-top: 0px;">
                          <div v-for="option in cat.Data" :key="option.Id"  style="position: relative;">
                            <v-btn fab text small style="position: absolute; right: 0; top: -10px;" @click="option.Expand = !option.Expand; forceUpdate()">
                              <v-icon v-if="!option.Expand">expand_more</v-icon>
                              <v-icon v-else>expand_less</v-icon>
                            </v-btn>    
                            <v-checkbox :disabled="!editMode" style="width: calc(100% - 55px);" v-model="option.Selected" :label="option.Label" hide-details v-on:change="resetOption($event, option)"></v-checkbox>
                            <div v-if="option.Expand">
                              <div style="padding: 15px 0 5px 0;">{{option.Description}}</div>
                              <div v-show="option.Selected" style="padding-top: 15px;">
                                <div v-if="!option.Edit" style="padding-bottom: 15px;">
                                  <span v-if="option.OptionValue">{{option.OptionValue}}</span><span v-else>No Value Set</span>
                                  <v-icon v-if="editMode" @click="option.Edit = true; option.JSONVerified = null; forceUpdate()" style="position: absolute; right: 16px;">create</v-icon>
                                </div>
                                <v-layout v-else>
                                  <v-flex xs10>
                                    <v-textarea :disabled="!editMode" filled name="Value" placeholder="Option Value" v-model="option.TempValue" v-show="option.Edit" hint="Not all options need values, if value is JSON please verify it."></v-textarea>
                                  </v-flex>
                                  <v-flex xs2  style="text-align: center; padding-left: 16px">
                                    <v-icon @click="option.Edit = false; option.OptionValue = option.TempValue; option.JSONVerified = null; forceUpdate()" class="verify-json">done</v-icon>
                                    <v-icon @click="option.Edit = false; resetOption(option); forceUpdate()" class="verify-json cancel-edit-option">close</v-icon>
                                    <br>
                                    <div @click="option.JSONVerified = verifyJson(option.TempValue); forceUpdate();" class="verify-json" style="margin: 10px 0; padding: 5px 0;">Verify<br/>JSON</div>
                                    <div v-if="option.JSONVerified" :style="{'color': option.JSONVerified == 'Valid' ? 'green' : '#ff5252'}">{{option.JSONVerified}}</div>
                                  </v-flex>
                                </v-layout>
                              </div>
                              <v-divider/>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-card-text>
                  <p class="center" v-if="error">{{error}}</p>
                </v-card-text>
              </div>
            </v-container>
          </v-card-text>
  <!----Location Settings---->
          <v-card-text id="location-detail" v-if="currentDialog == 'locationOverview' && editLocationModel" style="padding: 0;">
            <v-container>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Location Name" v-model="editLocationModel.Name" prepend-icon="location_on" :rules="[rulesRequired]"></v-text-field>
                </v-flex>
                <v-flex xs6 px-3 class="center-content">
                  <v-checkbox :disabled="!editMode" v-model="editLocationModel.IsActive" label="Active"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Address Line 1" v-model="editLocationModel.Address.Line1" :rules="[rulesRequired]"></v-text-field>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Address Line 2" v-model="editLocationModel.Address.Line2"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="City" v-model="editLocationModel.Address.City" :rules="[rulesRequired]"></v-text-field>
                </v-flex>
                <v-flex xs2 px-2>
                  <v-select  :disabled="!editMode" :items="states" v-model="editLocationModel.Address.State" label="State" :rules="[rulesRequired]"></v-select>
                </v-flex>
                <v-flex xs4 px-3>
                  <v-text-field  :disabled="!editMode" label="Zip" v-model="editLocationModel.Address.Zip" :rules="[rulesRequired, rulesZip]"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs7 px-3>
                  <v-text-field  :disabled="!editMode" label="Phone Number" v-model="editLocationModel.Address.Phone" prepend-icon="phone" :rules="[rulesPhone]"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs7 px-3>
                  <v-text-field  :disabled="!editMode" label="Broadcast Phone Number" v-model="editLocationModel.BroadcastPhone" prepend-icon="phone" :rules="[rulesPhone]"></v-text-field>
                </v-flex>
              </v-layout>
              <div class="form-title">Coolant Expiration (8)</div>
              <v-layout>
                <v-flex xs6 px-3>
                  <v-select :disabled="!editMode" :items="coolantExpirationOptions" v-model="editLocationModel.coolant" label="Coolant Calculation Source" item-text="Label" item-value="Value"></v-select>
                </v-flex>
                <v-flex xs3 px-3>
                  <v-menu :close-on-content-click="false" :nudge-right="33" :nudge-bottom="46"  :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-on="on" prepend-icon="access_time" :value="formatTime(editLocationModel.CoolantStartTime, 'AmPm')" :disabled="!editMode"  label="Start Time" readonly></v-text-field>
                    </template>
                    <v-time-picker style="" v-if="editMode" :disabled="!editMode" v-model="editLocationModel.CoolantStartTime"></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 px-3>
                  <v-text-field  :disabled="!editMode" label="Expiration" suffix="hrs" v-model="editLocationModel.CoolantExpirationHours" type="number"></v-text-field>
                </v-flex>
              </v-layout>   
              <div class="form-title">Shippers<v-btn v-if="editMode" depressed small px-3 style="float: right; margin: 0 16px 0 0;" @click="addShipper()">Add</v-btn></div>
              <v-layout row style="width: 100%">
                <v-flex xs12 px-3>
                  <v-data-table :mobile-breakpoint="0" :items="editLocationModel.Shippers" item-key="Id" :headers="headers.locationDialogHeaders" hide-default-footer >
                    <template v-slot:item="{ item }" item-key="HashKey">
                      <tr v-if="!item.delete" v-on:mouseenter="itemHover(item, true)" v-on:mouseleave="itemHover(item, false)"> 
                        <td>
                          <span v-if="!editMode">{{getShipperName(item.Key)}}</span>
                          <v-select v-else :disabled="!editMode" :items="shipperLabels" v-model="item.Key" label="Shipper Type" item-text="Label" item-value="Key" :rules="[rulesRequired]"></v-select>
                        </td>
                        <td class="center-content">
                          <span v-if="!editMode">{{item.Value}}</span>
                          <v-text-field v-else class="text-xs-center" :disabled="!editMode" label="Account #" single-line v-model="item.Value" :rules="[rulesRequired]"></v-text-field>
                        </td>
                        <td>
                          <v-btn icon v-on:click="item.delete = true; forceUpdate();">
                            <v-icon v-if="editMode && item.hover == true">delete</v-icon>
                          </v-btn> 
                        </td>              
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <div class="form-title">Workflow Settings</div>
              <v-layout>
                <v-flex xs5 px-3>
                  <div class="form-label">Weekday Cutoff</div>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-menu :close-on-content-click="false" :nudge-right="33" :nudge-bottom="46"  :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-on="on" prepend-icon="access_time" :value="formatTime(editLocationModel.WorkflowCutoff, 'AmPm')" :disabled="!editMode"  label="Start Time" :rules="[rulesRequired]" readonly></v-text-field>
                    </template>
                    <v-time-picker v-if="editMode" :disabled="!editMode" v-model="editLocationModel.WorkflowCutoff"></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs5 px-3>
                  <div class="form-label">Weekend Cutoff</div>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-menu :close-on-content-click="false" :nudge-right="33" :nudge-bottom="46"  :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-on="on" prepend-icon="access_time" :value="formatTime(editLocationModel.WorkflowCutoffWeekend, 'AmPm')" :disabled="!editMode"  label="Start Time" :rules="[rulesRequired]" readonly></v-text-field>
                    </template>
                    <v-time-picker v-if="editMode" :disabled="!editMode" v-model="editLocationModel.WorkflowCutoffWeekend"></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs5 px-3>
                  <div class="form-label">Calamity Threshold</div>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Threshold" single-line v-model="editLocationModel.CalamityThreshold" :rules="[rulesRequired]" type="number"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 px-3>
                  <v-checkbox :disabled="!editMode" v-model="editLocationModel.DelaysProcess" label="Delays Process"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-checkbox :disabled="!editMode" v-model="editLocationModel.UseCourierCostLimit" label="Courier Cost Limit"></v-checkbox>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Limit" single-line v-model="editLocationModel.CourierCostLimit" prepend-icon="attach_money" :rules="[rulesRequired]" type="number"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 px-3>
                  <v-checkbox :disabled="!editMode" v-model="editLocationModel.AutoAttemptSaturdayUpgrade" label="Auto Attempt Sat. Upgrade"></v-checkbox>
                </v-flex>
              </v-layout>
              <div class="form-title">Import Settings</div>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-checkbox :disabled="!editMode" v-model="editLocationModel.UseHighValueThreshold" label="Hight Value Threshold"></v-checkbox>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Threshold" single-line v-model="editLocationModel.HighValueThreshold" prepend-icon="attach_money" :rules="[rulesRequired]" type="number"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs5 px-3>
                  <div class="form-label">File Lookup Value</div>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="File Lookup" single-line v-model="editLocationModel.FileLookup"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs5 px-3>
                  <div class="form-label">Escalation CC List</div>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="CC List" single-line v-model="editLocationModel.EscalationCCList"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-checkbox :disabled="!editMode" v-model="editLocationModel.UseAutoNotificationCalls" label="Use Auto Notification Calls"></v-checkbox>
                </v-flex>
                <v-flex xs6 px-3 class="center-content">
                  <v-checkbox :disabled="!editMode" v-model="editLocationModel.UseAutoCalamityCalls" label="Use Auto Calamity Calls"></v-checkbox>
                </v-flex>
              </v-layout>
              <div class="form-title">Call Options</div>
              <v-layout row>
                <v-flex xs6 px-3>
                  <div class="form-label">Delivery Reminders</div>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-menu :close-on-content-click="false" :nudge-right="33" :nudge-bottom="46"  :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-on="on" prepend-icon="access_time" :value="formatTime(editLocationModel.DeliveryReminder, 'AmPm')" :disabled="!editMode"  label="Start Time" :rules="[rulesRequired]" readonly></v-text-field>
                    </template>
                    <v-time-picker v-if="editMode" :disabled="!editMode" v-model="editLocationModel.DeliveryReminder"></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 px-3>
                  <v-checkbox :disabled="!editMode" v-model="editClient.Status" label="Signature"></v-checkbox>
                </v-flex>
              </v-layout>
              <div class="form-title">Auto Call Scripts <v-btn v-if="editMode" depressed small px-3 style="float: right; margin: 0 16px 0 0;" @click="addAutoCallScript()">Add</v-btn></div>
              <v-layout row style="width: 100%">
                <v-flex xs12 px-3>
                  <v-data-table :mobile-breakpoint="0" :items="editLocationModel.Scripts" class="no-wrap-th" item-key="AutoCallDefaultScriptId" :headers="headers.callOptionsDialogHeaders" hide-default-footer >
                    <template v-slot:item="{ item }" item-key="HashKey">
                      <tr v-if="!item.delete" v-on:mouseenter="itemHover(item, true)" v-on:mouseleave="itemHover(item, false)">
                        <td>
                          <span v-if="!editMode">{{item.Name}}</span>
                          <v-select v-else :items="getFilteredDefaultScripts(item.AutoCallDefaultScriptId)" v-on:change="setScript($event, item)" v-model="item.AutoCallDefaultScriptId" label="Coolant Calculation Source" item-text="Type" item-value="Id" single-line :rules="[rulesRequired]"></v-select>
                        </td>
                        <td class="center-content">
                          <v-checkbox :disabled="!editMode" style="position: relative; top: 10px; margin-top: 0; padding-top: 0;" v-model="item.IsDefault" v-on:change="updateScriptDefault($event, item)"></v-checkbox>
                        </td>
                        <td class="center-content">
                          <div @click="item.EditScript = item.Script; expanded = true" v-if="item.AutoCallDefaultScriptId">
                            <v-btn icon v-if="editMode && !item.IsDefault"><v-icon>create</v-icon></v-btn>
                            <v-btn icon v-else><v-icon>visibility</v-icon></v-btn>
                          </div>
                        </td>
                        <td class="center-content"><v-text-field  :disabled="!editMode" label="Script" single-line v-model="item.Transfer"></v-text-field></td>
                        <td class="center-content"><v-text-field  :disabled="!editMode" label="From" single-line v-model="item.From"></v-text-field></td>
                        <td>
                          <v-btn icon v-on:click="item.delete = true">
                            <v-icon v-if="editMode && item.hover == true">delete</v-icon>
                          </v-btn>   
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }" item-key="AutoCallDefaultScriptId">
                      <td :colspan="headers.length" style="padding: 0;">
                        <v-card text style="padding: 15px;">
                          <div v-if="!(editMode && !item.IsDefault)">
                            {{ item.Script }}
                          </div>
                          <v-textarea v-else v-model="item.EditScript" :auto-grow="true" style="padding-bottom: 7px;" hide-details outline />
                          <div style="text-align: center;">
                            <v-btn depressed v-on:click="expanded = false">Hide</v-btn>
                            <v-btn depressed v-if="editMode && !item.IsDefault" v-on:click="item.Script = item.EditScript; expanded = false;">Set Script</v-btn>
                          </div>
                        </v-card>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              
              <div class="form-title">Billing Options</div>
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Quickbooks Id" v-model="editLocationModel.InvoiceSettings.QuickBooksId"></v-text-field>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Quickbooks Term" v-model="editLocationModel.InvoiceSettings.QuickBooksTerm"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 px-3>
                  <v-checkbox :disabled="!editMode" v-model="editLocationModel.InvoiceSettings.AllowCcPayment" label="Allow Online CC Payment"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout justify-center v-if="editMode && newLocation">
                <v-btn depressed @click="saveLocation()">Add Location</v-btn>
              </v-layout>
            </v-container>
          </v-card-text>
  <!----Billing Options---->
          <v-card-text id="billing-options-detail" v-show="currentDialog == 'billingOptionsOverview'" style="padding: 0;">
            <v-container>
              <div class="form-title">Line Items <v-btn depressed small px-3 style="float: right; margin: 0 16px 0 0;" @click="addLineItem()" v-if="editMode">Add</v-btn></div>
              <v-layout row style="width: 100%">
                <v-flex xs12 px-3>
                  <v-data-table :mobile-breakpoint="0" :items="editClient.BillingLineItems" item-key="Id" :headers="headers.billingOptionsDialogHeaders" hide-default-footer >
                    <template v-slot:item="{ item }" item-key="HashKey">
                      <tr v-if="!item.delete" v-on:mouseenter="itemHover(item, true)" v-on:mouseleave="itemHover(item, false)">
                        <td>
                          <span v-if="!editMode">{{getLineItemName(item.LineItemId)}}</span>
                          <v-select v-else :items="getFilteredLineItems(item.LineItemId)" :rules="[rulesRequired]" v-model="item.LineItemId" single-line label="Select Line Item" item-text="Name" item-value="Id"/>
                        </td>
                        <td class="center-content">
                          <span v-if="!editMode">$ {{item.Fee}}</span>
                          <v-text-field v-else label="Fee" single-line v-model="item.Fee" :rules="[rulesRequired]" prepend-icon="attach_money" type="number"/>
                        </td>
                        <td>
                          <v-btn icon v-on:click="item.delete = true">
                            <v-icon v-if="editMode && item.hover == true">delete</v-icon>
                          </v-btn>   
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <div class="form-title">Billing Client Options</div>
              <v-layout>
                <v-flex xs6 px-3>
                  <v-checkbox :disabled="!editMode" v-model="editClient.InvoiceSettings.BillByLocation" label="Bill By Location"></v-checkbox>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-select :disabled="!editMode" :items="billingStructureOptions" :rules="[]" item-text="Type" item-value="Id" v-model="editClient.InvoiceSettings.BillingClientTypeId" label="Billing Structure Type" ></v-select>
                </v-flex>
              </v-layout> 
              <v-layout row>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Quickbooks Id" v-model="editClient.InvoiceSettings.QuickBooksId"></v-text-field>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field  :disabled="!editMode" label="Quickbooks Term" v-model="editClient.InvoiceSettings.QuickBooksTerm"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 px-3>
                  <v-checkbox :disabled="!editMode" v-model="editClient.InvoiceSettings.AllowCcPayment" label="Allow Online CC Payment"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-form>
      </v-card>
    </div>
  </v-dialog>
  <!-- eslint-enable -->
</template>
<!-- eslint-disable -->
<style>
  .client-dialog-form .center-content .v-input__slot {justify-content: center;}
  .client-dialog-form .form-title {font-weight: bold; font-size: 18px; padding-top: 20px;}
  .client-dialog-form .form-label {padding-top: 20px; font-size: 16px;}
</style>
<!-- eslint-enable -->
<script>
import { CLIENT_SETTINGS_NAMESPACE } from "./../store/clientSettingsStore";
import { mapGetters } from "vuex";
import RulesMixin from "@/mixins/RulesMixin.js";
import US_STATES from "@/assets/data/US_STATES";
import moment from "moment";

export default {
  name: "ClientDialog",
  mixins: [RulesMixin],
  data() {
    return {
      shipperLabels: [
        {
          Key: "Other",
          Label: "Other"
        },
        {
          Key: "UPSAccountNumber",
          Label: "UPS"
        },
        {
          Key: "FedExAirAccountNumber",
          Label: "FedEx Air"
        },
        {
          Key: "FedExGroundAccountNumber",
          Label: "FedEx Ground"
        }
      ],
      update: false,
      callOptionsModel: null,
      clientOptionEditData: {},
      coolantExpirationOptions: [
        {
          Label: "Origin",
          Value: "ORIGIN"
        },
        {
          Label: "Manifest",
          Value: "MANIFEST"
        },
        {
          Label: "Client Ship Date",
          Value: "FILE"
        }
      ],
      currentDialog: "clientOverview",
      dialog: false,
      editClient: {
        Address: {},
        Locations: [],
        CallOptions: {},
        Options: [],
        InvoiceSettings: {}
      },
      editClientId: null,
      editMode: false,
      editLocationModel: null,
      editUserLocationModel: [],
      error: null,
      headers: {
        clientDialogHeaders: [
          {
            text: "Name",
            sortable: true,
            value: "Name",
            align: "left"
          },
          {
            text: "Is Active",
            align: "center",
            sortable: false
          }
        ],
        locationDialogHeaders: [
          {
            text: "Shipper",
            sortable: true,
            value: "Key",
            align: "left"
          },
          {
            text: "Account #",
            sortable: true,
            value: "Value",
            align: "left"
          },
          { sortable: false }
        ],
        callOptionsDialogHeaders: [
          {
            text: "Name",
            sortable: true,
            value: "Name",
            align: "left"
          },
          {
            text: "Default",
            align: "center",
            sortable: false
          },
          {
            text: "Script",
            align: "center",
            sortable: false
          },
          {
            text: "Transfer",
            align: "center",
            sortable: false
          },
          {
            text: "From",
            align: "center",
            sortable: false
          },
          {
            sortable: false
          }
        ],
        billingOptionsDialogHeaders: [
          {
            text: "Line Item",
            sortable: true,
            value: "LineItem",
            align: "left"
          },
          {
            text: "Amount",
            sortable: true,
            value: "Amount",
            align: "left"
          },
          {
            sortable: false
          }
        ]
      },
      newDeliveryReminder: false,
      newEditId: 1,
      newLocation: false,
      passVisible: true,
      reminderScriptModel: null,
      resetPassword: false,
      rules: {
        defaultValue: v => {
          if (!v && this.editClient.UseDefaultValue === true) {
            return "Required if Default is Selected";
          }
          return true;
        },
        number: v => {
          if (isNaN(v) && v && (v + "").trim() !== "") {
            return "Must Be A Number";
          }
          return true;
        }
      },
      showClientOptions: false,
      states: US_STATES,
      userNameError: null,
      valid: false
    };
  },
  computed: {
    ...mapGetters(CLIENT_SETTINGS_NAMESPACE, [
      "billingStructureOptions",
      "loadingClientOptions",
      "optionList",
      "selectedClient",
      "billingLineItems",
      "defaultScripts",
      "savingClient"
    ])
  },
  created() {
    this.$parent.$on("clientEdit", this.show);
  },
  methods: {
    getShipperName(key) {
      var shipper = this.shipperLabels.find(x => x.Key === key);
      if (shipper) return shipper.Label;
    },
    getFilteredLineItems(id) {
      return this.billingLineItems.filter(x => {
        if (x.Id === id) return true;
        else {
          var item = this.editClient.BillingLineItems.find(
            y => y.LineItemId === x.Id && !y.delete
          );
          if (item) return false;
          else return true;
        }
      });
    },
    getFilteredDefaultScripts(id) {
      return this.defaultScripts.filter(x => {
        if (x.Id === id) return true;
        else {
          var item = this.editLocationModel.Scripts.find(
            y => y.AutoCallDefaultScriptId === x.Id && !y.delete
          );
          if (item) return false;
          else return true;
        }
      });
    },
    formatTime(time, type) {
      if (time) {
        if (type === "24hr") return moment(time, ["h:mm A"]).format("HH:mm");
        else if (type === "AmPm")
          return moment(time, ["HH:mm"]).format("hh:mm A");
      }
    },
    itemHover(item, hover) {
      item.hover = hover;
      this.forceUpdate();
    },
    updateScriptDefault($event, script) {
      if ($event) {
        script.Script = script.DefaultScript;
      }
      script.IsDefault = $event;
      this.update = !this.update;
      var temp = JSON.stringify(this.editLocationModel);
      this.editLocationModel = null;
      this.$forceUpdate();
      this.editLocationModel = JSON.parse(temp);
      this.$forceUpdate();
    },
    setScript($event, item) {
      var script = this.defaultScripts.find(x => x.Id === $event);
      if (script) {
        item.Script = script.DefaultScript.Script;
        item.EditScript = script.DefaultScript.Script;
        this.$forceUpdate();
      }
    },
    getLineItemName(id) {
      var item = this.billingLineItems.find(x => x.Id === id);
      if (item) return item.Name;
    },
    addLineItem() {
      this.editClient.BillingLineItems.push({
        Id: null,
        Fee: 0,
        LineItemId: null,
        ClientId: this.editClient.Id
      });
    },
    addShipper() {
      this.editLocationModel.Shippers.push({
        Key: null,
        Value: null
      });
    },
    addAutoCallScript() {
      this.editLocationModel.Scripts.push({
        LocationId: this.editLocationModel.Id
      });
    },
    back() {
      if (this.currentDialog === "locationOverview") {
        this.currentDialog = "clientOverview";
        this.editLocationModel = null;
      } else if (this.currentDialog === "callOptionsOverview") {
        if (this.editLocationModel) {
          this.currentDialog = "locationOverview";
        } else {
          this.currentDialog = "clientOverview";
        }
      } else if (this.currentDialog === "billingOptionsOverview") {
        this.currentDialog = "clientOverview";
      } else if (this.currentDialog === "clientOptionsOverview") {
        this.currentDialog = "clientOverview";
      }
    },
    close() {
      this.dialog = false;
    },
    edit() {
      this.editMode = true;
    },
    closeEdit() {
      this.makeClientOptionsData();
      this.editClient = _.cloneDeep(this.selectedClient);
      this.editMode = false;
      this.forceUpdate();
    },
    editLocation(location) {
      if (!location) {
        this.newLocation = true;
        location = {
          ClientId: this.editClient.Id,
          Address: {},
          Shippers: [],
          BillingOptions: {
            LineItems: []
          },
          InvoiceSettings: {},
          Scripts: []
        };
      } else {
        if (!location.Address) location.Address = {};
        if (location.Scripts) {
          location.Scripts.forEach(x => {
            var script = this.defaultScripts.find(
              y => y.Id === x.AutoCallDefaultScriptId
            );
            if (script) {
              x.Name = script.Type;
              x.IsDefault = x.Script === script.DefaultScript.Script;
              x.DefaultScript = script.DefaultScript.Script;
            }
          });
        }
      }
      this.currentDialog = "locationOverview";
      this.editLocationModel = location;
    },
    forceUpdate() {
      this.editMode = !this.editMode;
      this.editMode = !this.editMode;
      this.$forceUpdate();
    },
    makeClientOptionsData() {
      this.clientOptionEditData = {};
      this.optionList.forEach(o => {
        if (!this.clientOptionEditData[o.CategoryName])
          this.clientOptionEditData[o.CategoryName] = {
            Name: this.snakeCaseToTitleCase(o.CategoryName),
            Data: [],
            Id: o.OptionCategoryId
          };
        var data = {
          Id: null,
          Label: this.snakeCaseToTitleCase(o.Name),
          Name: o.Name,
          Description: o.Description,
          Selected: false,
          OptionValue: o.DefaultValue,
          OptionId: o.Id,
          ClientId: this.selectedClient.Id,
          Edit: false,
          JSONVerified: null,
          Expand: false,
          SelectedOrig: false
        };
        let option = this.selectedClient.Options.find(x => x.OptionId === o.Id);
        if (option) {
          data.Id = option.Id;
          data.Selected = true;
          data.OptionValue = option.OptionValue;
          data.SelectedOrig = true;
          data.ValueOrig = option.OptionValue;
        }
        data.TempValue = data.Value;
        this.clientOptionEditData[o.CategoryName].Data.push(data);
      });
    },
    reset() {
      this.newLocation = false;
      this.dialog = false;
      this.editClient = {
        Address: {},
        Locations: [],
        CallOptions: {},
        Options: [],
        InvoiceSettings: {}
      };
      this.$refs.form.reset();
      this.currentDialog = "clientOverview";
    },
    resetOption($event, option) {
      option.Edit = false;
      option.TempValue = option.Value;
      option.JSONVerified = null;
      this.forceUpdate();
    },
    saveClient() {
      if (this.$refs.form.validate()) {
        this.editClient.Options = [];

        for (var key in this.clientOptionEditData) {
          this.clientOptionEditData[key].Data.forEach(x => {
            if (
              x.SelectedOrig !== x.Selected ||
              (x.SelectedOrig && x.OptionValue !== x.ValueOrig)
            )
              this.editClient.Options.push({
                Id: x.Id,
                OptionId: x.OptionId,
                OptionValue: x.OptionValue,
                ClientId: this.editClient.Id,
                selected: x.Selected
              });
          });
        }

        if (!this.editClient.InvoiceSettings.Client) {
          this.editClient.InvoiceSettings.Client = {
            Id: this.editClient.Id
          };
          this.editClient.InvoiceSettings.BillingClientTypeId = 1;
          this.editClient.InvoiceSettings.isNew = true;
        }
        this.editClient.Locations.forEach(loc => {
          if (!this.editClient.InvoiceSettings.Location) {
            loc.InvoiceSettings.Location = {
              Id: loc.Id
            };
            loc.InvoiceSettings.ClientId = this.editClient.Id;
            this.editClient.hasNewLocationInvoiceSetting = true;
          }
        });

        this.editClient.BillingLineItems.forEach(x => {
          x.LineItemTierTypeId = 1;
        });
        this.makeShipperSubmitData();
        var saveClient = _.cloneDeep(this.editClient);
        this.formatSelectedClientTimes(saveClient, "AmPm");
        this.$store
          .dispatch(
            `${CLIENT_SETTINGS_NAMESPACE}/saveClientDetails`,
            saveClient
          )
          .then(() => {
            if (!saveClient.Id) this.loadClients();
            this.close();
          });
      }
    },
    loadClients() {
      this.$store.dispatch(`${CLIENT_SETTINGS_NAMESPACE}/loadClients`);
    },
    saveLocation() {
      if (!this.editLocationModel.Id) {
        if (!this.editLocationModel.newEditId) {
          this.editLocationModel.newEditId = this.newEditId;
          this.newEditId++;
          this.editClient.Locations.push(this.editLocationModel);
        } else {
          var loc = this.editClient.Locations.find(x => {
            return x.newEditId === this.editLocationModel.newEditId;
          });
          if (loc) loc = this.editLocationModel;
        }
      } else {
        var index = -1;
        this.editClient.Locations.forEach((x, idx) => {
          if (x.Id === this.editLocationModel.Id) index = idx;
        });
        if (index > -1)
          this.editClient.Locations[index] = this.editLocationModel;
      }
      this.editLocationModel = null;
      this.newLocation = false;
      this.currentDialog = "clientOverview";
    },
    formatSelectedClientTimes(client, type) {
      if (client.CoolantStartTime)
        client.CoolantStartTime = this.formatTime(
          client.CoolantStartTime,
          type
        );

      client.Locations.forEach(loc => {
        loc.WorkflowCutoff = this.formatTime(loc.WorkflowCutoff, type);
        loc.WorkflowCutoffWeekend = this.formatTime(
          loc.WorkflowCutoffWeekend,
          type
        );
        loc.DeliveryReminder = this.formatTime(loc.DeliveryReminder, type);
      });
    },
    show(mode) {
      if (this.$refs.form) this.$refs.form.reset();
      this.formatSelectedClientTimes(this.selectedClient, "24hr");
      this.makeClientOptionsData();
      this.makeShipperData();
      this.editClient = _.cloneDeep(this.selectedClient);
      this.dialog = true;
      this.currentDialog = "clientOverview";
      this.editMode = false;
      if (mode === 1) {
        this.editMode = true;
      }
    },
    makeShipperSubmitData() {
      this.editClient.Locations.forEach(loc => {
        var shipperNumber = [];
        loc.Shippers.forEach(ship => {
          if (!ship.delete) {
            shipperNumber.push(ship.Value);
            if (ship.Key === "UPSAccountNumber")
              loc.UPSAccountNumber = ship.Value;
            else if (ship.Key === "FedExAirAccountNumber")
              loc.FedExAirAccountNumber = ship.Value;
            else if (ship.Key === "FedExGroundAccountNumber")
              loc.FedExGroundAccountNumber = ship.Value;
          }
        });
        if (shipperNumber.length > 0)
          loc.ShipperAccountNumber = shipperNumber.join(", ");
        else loc.ShipperAccountNumber = null;
      });
    },
    makeShipperData() {
      this.selectedClient.Locations.forEach(loc => {
        var shippers = [];
        var shipperNumbers = [];
        if (loc.ShipperAccountNumber)
          shipperNumbers = loc.ShipperAccountNumber.split(",").map(item =>
            item.trim()
          );
        shipperNumbers.forEach(x => {
          var key = "Other";
          if (x === loc.UPSAccountNumber) key = "UPSAccountNumber";
          else if (x === loc.FedExAirAccountNumber)
            key = "FedExAirAccountNumber";
          else if (x === loc.FedExGroundAccountNumber)
            key = "FedExGroundAccountNumber";

          shippers.push({
            Key: key,
            Value: x
          });
        });
        loc.Shippers = shippers;
      });
    },
    snakeCaseToTitleCase(s) {
      if (!s) s = "";
      var camel = s
        .toLowerCase()
        .replace(/_([a-z])/g, function(m) {
          return m.toUpperCase();
        })
        .replace(/_/g, "");
      var pascal = `${camel.charAt(0).toUpperCase()}${camel.substr(1)}`;
      return pascal.replace(/([A-Z])/g, " $1").trim();
    },
    verifyJson(jsonContent) {
      if (!jsonContent) return "Invalid";
      try {
        JSON.parse(jsonContent);
        return "Valid";
      } catch (e) {
        return "Invalid";
      }
    },
    viewBillingOptions() {
      this.currentDialog = "billingOptionsOverview";
    },
    viewCallOptions(model) {
      this.currentDialog = "callOptionsOverview";
    },
    viewClientOptions() {
      this.currentDialog = "clientOptionsOverview";
    }
  }
};
</script>
